import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { exchangeKeycloakCode } from '../../utils/Api';

type KeycloakCallbackProps = {
  setToken: (token: string) => void;
};

const KeycloakCallback: React.FC<KeycloakCallbackProps> = ({ setToken }) => {
  const navigate = useNavigate();
  const requestSent = useRef(false);

  useEffect(() => {
    if (requestSent.current) return; // Prevent duplicate execution in strict mode
    requestSent.current = true;

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");

    if (!code) {
      console.error("Authorization code not found");
      navigate("/login");
      return;
    }

    const handleAuth = async (code: string) => {
      try {
        const { data } = await exchangeKeycloakCode(code);

        if (data.access_token) {
          setToken(data.access_token);
        } else {
          console.error("Failed to get token:", data);
          navigate("/login");
        }
      } catch (error: any) {
        console.error("Error during token exchange:", error);
        navigate("/login");
      }
    };

    handleAuth(code);
  }, [navigate, setToken]);

  return <p>Processing authentication...</p>;
};

export default KeycloakCallback;
